<template>
  <WelcomeDashboard />
  <div class="main-content-containers overflow-hidden">
    <!-- <h2>Welcome!</h2>
    <p>Work on progress.</p> -->
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <!-- <RecentOrders /> -->
      </div>
      <div class="col-lg-4">
        <div class="row justify-content-center">
          <div class="col-md-4 col-lg-12">
            <!-- <TotalOrdersChart /> -->
          <!--</div>
          <div class="col-md-4 col-lg-12">-->
            <!-- <OrderSummaryChart /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { schoolDetail, classNames,totalCountForDashboard } from "@/services/apiServices";
import { useSchoolStore, useClassStore } from "@/Store/className.js"
import WelcomeDashboard from "../components/Dashboard/LMS/WelcomeDashboard.vue";
//import TotalOrdersChart from "../components/Dashboard/Ecommerce/TotalOrdersChart.vue";
//import RecentOrders from "../components/Dashboard/Ecommerce/RecentOrders.vue";
//import OrderSummaryChart from "../components/Dashboard/Ecommerce/OrderSummaryChart.vue";

const schoolStore = useSchoolStore();
const classStore = useClassStore();
const fetchSchool = async () => {
  try {
    const data = await schoolDetail();
    schoolStore.setSchoolInfoList(JSON.stringify(data))
  } catch (err) {
    console.error(err.response?.data?.message || "Failed to load school details");
  }
};

const fetchClasss = async () => {
  try {
    const data = await classNames();
    // console.log("class", data)
    // // classStore.setClassInfoList(JSON.stringify(data));
    // classStore.setClassInfoList(data);
  } catch (err) {
    // console.log(err)
    console.error(err.response?.data?.message || "Failed to load fetchClasss details");
  }
};


onMounted(async () => {
  await fetchSchool();
  await fetchClasss();

});
</script>


<style scoped>
.main-content-containers {
  max-width: 1120px;
  margin: auto;
  width: 100%;
}
</style>